
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/miracle-of-mind/[firstLevel]",
      function () {
        return require("private-next-pages/[region]/[language]/miracle-of-mind/[firstLevel]/index.mom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/miracle-of-mind/[firstLevel]"])
      });
    }
  